
import Suggestions from '../components/Suggestions';

const Home = () => {
    return (
        <Suggestions/>
    )
}

export default Home